// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"nE","checkbox":"nF","labelText":"nG","optText":"nH"};